import type {FC} from 'react'

interface Props {
  tabs: string[]
  contents: JSX.Element[]
}

const TabsDefault: FC<Props> = ({tabs, contents}) => {
  return (
    <>
      <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 px-8 fs-6'>
        {tabs.map((tab, index) => (
          <li key={index} className='nav-item'>
            <a
              className={`nav-link ${index === 0 ? 'active' : ''}`}
              data-bs-toggle='tab'
              href={`#tab_panel_${index}`}
            >
              {tab}
            </a>
          </li>
        ))}
      </ul>
      <div className='tab-content px-8 pb-8' id='MyTabContent'>
        {contents.map((content, index) => (
          <div
            key={index}
            className={`tab-pane fade show ${index === 0 ? 'active' : ''}`}
            id={`tab_panel_${index}`}
            role='tabpanel'
          >
            {content}
          </div>
        ))}
      </div>
    </>
  )
}

export default TabsDefault
